<template>
  <div>
    <p class="section-title">
      <img src="@/assets/quiz.png" />
      クイズミッション
    </p>
    <ul
      class="mission-list"
      v-for="(mission, index) in missonList"
      :key="index"
    >
      <li @click="onClick(mission)">
        <p>
          {{
            mission.mission_title
              ? mission.mission_title
              : "名称未設定のミッションです"
          }}
        </p>
        <img class="chev" src="@/assets/chevron.svg" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "quiz-mission-list",
  props: {
    missonList: { type: Array, require: true },
  },
  methods: {
    onClick(mission) {
      this.$emit("click-mission", mission);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.section-title {
  display: flex;
  align-items: center;
  margin: 0.25rem 0;
  img {
    margin-right: 0.5rem;
    height: 1.2rem;
  }
  p {
    line-height: 20px;
  }
}

.mission-list {
  list-style: none;
  padding-left: 0;
  border-bottom: 1px #e7e7e7 solid;
  li {
    margin: 0;
    display: flex;
    padding: 1rem 0.5rem;
    border-top: 1px #e7e7e7 solid;
    position: relative;
    align-items: center;
    p {
      margin: 0;
      width: calc(100% - 1.2rem);
    }
    .chev {
      transform: rotate(-90deg);
      height: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuizMission/List.vue